import { FC, useState } from 'react';

import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import LabelSelector from '~src/modules/okrs/manageObjectives/shared/labels/LabelSelector';
import {
  ObjectiveItem,
  OkrLabel,
  ObjectiveItemUpdate,
  ObjectiveStatus,
} from '~src/store/okrs/interfaces';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import { LabelsWrapper } from '~src/modules/okrs/manageObjectives/shared/shared.sc';

interface OwnProps {
  hasChangePermissions: boolean;
  objective: ObjectiveItem;
  update: (values: Partial<ObjectiveItemUpdate>) => ApiReduxResp<ObjectiveItem>;
}

type Props = OwnProps;

const LabelsEdit: FC<Props> = props => {
  const [currentLabels, setCurrentLabels] = useState(props.objective.labels || []);

  const changeLabels = async (labels: OkrLabel[]) => {
    await props.update({ labels: labels.map(label => label.id) });
    setCurrentLabels(labels);
  };
  const isEnabled = props.hasChangePermissions && props.objective.status !== ObjectiveStatus.CLOSED;

  return (
    <LabelsWrapper>
      <SelectorHandler hoverTextKey="x.objective.add.icon.labels" iconName="iconLabel">
        {() => <LabelSelector frozen={!isEnabled} labels={currentLabels || []} onChange={changeLabels} />}
      </SelectorHandler>
    </LabelsWrapper>
  );
};

export default LabelsEdit;
